import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import { getWebPageSchema, getBreadcrumbSchema } from '@/lib/schema';

export default function SicurezzaPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd schema={getWebPageSchema('/sicurezza', 'Centro Sicurezza Itaobuy Spreadsheet', 'Scopri come acquistare in sicurezza con Itaobuy Spreadsheet. Guide su verifica venditori, protezione dati, pagamenti sicuri e QC photos per lo shopping internazionale.')} />
      <JsonLd schema={getBreadcrumbSchema([{ name: 'Home', url: '/' }, { name: 'Sicurezza', url: '/sicurezza' }])} />
      <Navbar />
      <section className="w-full px-6 md:px-10 pt-28 pb-12 bg-background-100">
        <div className="max-w-4xl mx-auto">
          <nav className="flex items-center gap-2 text-xs font-body text-foreground-500 mb-6 flex-wrap">
            <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">Home</Link>
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-arrow-right-s-line text-xs"></i>
            </span>
            <span className="text-foreground-400 whitespace-nowrap">Sicurezza</span>
          </nav>
          <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight mb-4">
            Centro Sicurezza Itaobuy Spreadsheet
          </h1>
          <p className="font-body text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
            La tua sicurezza è la nostra priorità. Scopri come riconoscere venditori affidabili, proteggere i tuoi dati personali e fare acquisti in totale tranquillità con Itaobuy Spreadsheet.
          </p>
          <div className="flex flex-wrap gap-4">
            <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-label text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-arrow-left-line text-sm"></i>
              Torna alla Home
            </Link>
          </div>
        </div>
      </section>
      <section className="w-full px-6 md:px-10 py-16">
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[
              { title: "Verifica Venditori", desc: "Impara a riconoscere i venditori affidabili e a evitare potenziali truffe. Controlla sempre le recensioni, la data di creazione del negozio e il numero di transazioni completate.", icon: "ri-shield-user-line" },
              { title: "Protezione Dati", desc: "Non condividere mai informazioni personali sensibili con i venditori. Utilizza sempre i canali di comunicazione ufficiali e metodi di pagamento sicuri per ogni transazione.", icon: "ri-lock-line" },
              { title: "Pagamenti Sicuri", desc: "Utilizza metodi di pagamento che offrono protezione acquirente. Evita bonifici diretti e preferisci piattaforme che offrono garanzie in caso di problemi con l'ordine.", icon: "ri-bank-card-line" },
              { title: "QC Photos", desc: "Richiedi sempre foto QC (Quality Check) prima della spedizione. Questo ti permette di verificare le condizioni reali del prodotto e identificare eventuali difetti.", icon: "ri-camera-line" },
            ].map((item, i) => (
              <div key={i} className="bg-background-50 border border-background-200 rounded-xl p-6">
                <span className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center mb-4">
                  <i className={`${item.icon} text-accent-600 text-lg`}></i>
                </span>
                <h3 className="font-label text-sm font-semibold text-foreground-900 mb-2">{item.title}</h3>
                <p className="font-body text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}